import axios from "axios";
import BASE_URL from "../config/host";
import Cookies from "js-cookie";

export const fetchProfileDetails = async (
  id,
  setList,
  setLoaded = () => {}
) => {
  setLoaded(false);
  const token = localStorage.getItem("auth_token") || Cookies.get("auth_token");
  try {
    let data = await axios.get(`${BASE_URL}/user/details/${id}`, {
      params: { _t: Date.now() },
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    if (data?.status === 200) {
      if (typeof setList === "function") {
        setList(data?.data?.docs);
      }
      setLoaded(true);
    }

    return data?.data || { status: data?.status || 200 };
  } catch (error) {
    setLoaded(true);
    return error?.response?.data || error?.response || { status: error?.response?.status || 500, error };
  }
};

export const fetchCountryList = async (setList, setLoaded = () => {}) => {
  setLoaded(false);
  try {
    let response = await axios.get(`${BASE_URL}/countries`, {
      params: {
        limit: 300,
      },
    });

    if (response.status === 200) {
      setList(response?.data?.docs?.data);
      setLoaded(true);
    }

    return response;
  } catch (error) {
    setLoaded(true);
    return error.response;
  }
};

export const updateProfileService = async (params, setLoaded = () => {}) => {
  setLoaded(false);
  const formData = new FormData();
  const token = localStorage.getItem("auth_token") || Cookies.get("auth_token");

  Object.keys(params).forEach((key) => {
    formData.append(key, params[key]);
  });

  try {
    let response = await axios.put(
      `${BASE_URL}/user/edit`,
      {
        ...params,
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      setLoaded(true);
    }

    return response;
  } catch (error) {
    setLoaded(true);
    return error.response;
  }
};

export const changePasswordService = async (params, setLoaded = () => {}) => {
  setLoaded(false);
  const token = localStorage.getItem("auth_token") || Cookies.get("auth_token");

  try {
    let response = await axios.put(
      `${BASE_URL}/profile/change-password`,
      {
        ...params,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200) {
      setLoaded(true);
    }

    return response;
  } catch (error) {
    setLoaded(true);
    return error.response;
  }
};
